import { render, staticRenderFns } from "./TaxPaymentAccount.vue?vue&type=template&id=ea355ef4&scoped=true"
import script from "./TaxPaymentAccount.vue?vue&type=script&lang=js"
export * from "./TaxPaymentAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea355ef4",
  null
  
)

export default component.exports